import { InstructionSearchResponse, ProductListResource } from "@/api/generated-api";
import { SearchProductsRequestType, SearchServiceCenterRequestType } from "@/api/search/types";
import ApiClient from "../ampm-world";

export class ApiSearch {
  static async getServiceCenterSearch({
    categoryId,
    pageNumber,
    q,
    lang,
  }: SearchServiceCenterRequestType): Promise<InstructionSearchResponse> {
    const finalQuery = { page_size: 20, page_number: pageNumber, category_id: categoryId, q };

    const data = await ApiClient.get<InstructionSearchResponse>(`/${lang}/search/instructions`, finalQuery);

    return data;
  }

  static async getSearchProducts(payload: SearchProductsRequestType): Promise<ProductListResource> {
    const finalQuery = { page_size: 12, page_number: payload.pageNumber, q: payload.q };

    const data = await ApiClient.get<ProductListResource>(`/${payload.lang}/search/products`, finalQuery);

    return data;
  }
}
